import React from "react";
import { Table } from "react-bootstrap"
import styled from "styled-components";

const Icon = styled.div`
cursor: pointer;
text-alig: center
`

export default props => {
    if (props.payments.length) {
        return <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>Forma de pagamento</th>
                    <th>Valor pago</th>
                    <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.payments.map((payment, index) => <tr key={`sale-payments-index-${index}-${payment.id}`}>
                        <td>{payment.paymentName}</td>
                        <td>{payment.displayValue}</td>
                        <td>
                            <Icon>
                                <i onClick={() => props.removePayment(index)} className="fas fa-trash"></i>
                            </Icon>
                        </td>
                    </tr>)
                }
            </tbody>
        </Table>
    } else {
        return <React.Fragment />
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/Payment/PaymentsTable/index.jsx